var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modals-wrapper",class:{ 'modals-wrapper--active': _vm.modals.length > 0 },style:({ zIndex: _vm.zIndex })},[_vm._l((_vm.modals),function(modal){return _c('modal-base',{key:modal.id,attrs:{"modal":modal}})}),_c('div',{staticClass:"pbehavior-calendar-event-menu"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }